import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const style = () => ({
    root: {
        maxWidth: 150,
        display: 'flex',
    },
    text: {
        textAlign: 'center',
        marginTop: 15,
    }
});

const Pager = props => {
    return (
        <div className={props.classes.root}>
            <Grid container>
                <Grid item xs={3}>
                    <IconButton onClick={props.prevPageClick} disabled={props.currentPage <= 1}>
                        <ChevronLeft />
                    </IconButton>
                </Grid>
                <Grid item xs={6} className={props.classes.text}>
                    <Typography>
                        {props.currentPage} of {props.totalPages}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <IconButton onClick={props.nextPageClick} disabled={props.currentPage >= props.totalPages}>
                        <ChevronRight />
                    </IconButton>
                </Grid>
            </Grid>
        </div>
    );
};

Pager.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    nextPageClick: PropTypes.func.isRequired,
    prevPageClick: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    }).isRequired,
};

export default withStyles(style)(Pager);